import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { updateDocumenrVersionApi } from "../../../../../services/DocumentService";
import WordFileUpload from "../../../../constant/FileUpload";
import RichTextEditorComponent from "../../../../constant/RichTextEditor";
import { Tab, Nav } from "react-bootstrap";

const EditDocumentVersion = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state?.data || {};
  const updateActiveKey = location.state?.updateActiveKey || "";
  const [description, setDescription] = useState(
    data.version_description || ""
  );
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [documentData, setDocumentData] = useState(
    data.content || data.file || null
  );
  const [activeKey, setActiveKey] = useState(
    data.content ? "newDocument" : "uploadDocument"
  );

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (data) {
      setDescription(data.version_description || "");
      setDocumentData(data.content || data.file || null);
    }
  }, [data]);

  const validateInputs = () => {
    const validationErrors = {};
    if (!description.trim()) {
      validationErrors.description = "Description is required";
    }
    if (!documentData) {
      validationErrors.documentData = "Document content or file is required";
    }
    return validationErrors;
  };

  const handleEditorChange = (newValue) => {
    setDocumentData(newValue);
  };

  const handleFileSelect = (file) => {
    setDocumentData(file);
  };

  const handleSubmit = async (isDraft) => {
    const validationErrors = validateInputs();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      setIsSubmitLoading(true);
      const formData = new FormData();
      formData.append("id", data.id);
      formData.append("description", description);
      if (documentData instanceof File) {
        formData.append("file", documentData);
      } else {
        formData.append("content", documentData);
      }
      formData.append("is_draft", isDraft);
      const response = await updateDocumenrVersionApi(id, formData);
      toast.success(response.data.message);
      navigate(`/document/${id}`, { state: { activekey: updateActiveKey } });
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(`/document/${id}`, { state: { activekey: updateActiveKey } });
  };


  return (
    <div className="container-fluid">
      <div className="row px-sm-2 px-0">
        <div className="col-xl-12">
          <div className="card px-sm-3 px-1">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm btn-circle mb-4 me-3"
                  style={{ zIndex: 1050 }}
                  onClick={handleCancel}
                >
                  <i className="fa-solid fa-arrow-left"></i>
                </button>
                <h3 className="text-center mb-4">Edit Document Version</h3>
              </div>
              <form>
                <div className="form-group mb-3">
                  <label className="form-label">
                    Description<span className="text-danger">*</span>
                  </label>
                  <textarea
                    className={`form-control ${
                      errors.description ? "is-invalid" : ""
                    }`}
                    placeholder="Enter Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    rows="4"
                  />
                  {errors.description && (
                    <div className="invalid-feedback">{errors.description}</div>
                  )}
                </div>
                <div className="card">
                  <Tab.Container activeKey={activeKey} onSelect={setActiveKey}>
                    <div className="card-header p-0">
                      <Nav variant="tabs">
                        <Nav.Item>
                          <Nav.Link
                            eventKey="newDocument"
                            className="tabnav p-3"
                          >
                            <strong>New Document</strong>
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="uploadDocument"
                            className="tabnav p-3"
                          >
                            <strong>Upload Document</strong>
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </div>
                    <div className="card-body p-0">
                      <Tab.Content>
                        <Tab.Pane eventKey="newDocument">
                          {activeKey === "newDocument" && (
                            <RichTextEditorComponent
                              handleChange={handleEditorChange}
                              initialValue={data?.content}
                            />
                          )}
                        </Tab.Pane>
                        <Tab.Pane eventKey="uploadDocument">
                          {activeKey === "uploadDocument" && (
                            <WordFileUpload
                              onFileSelect={handleFileSelect}
                              initialValue={data?.file?.name}
                            />
                          )}
                        </Tab.Pane>
                      </Tab.Content>
                    </div>
                  </Tab.Container>
                </div>
                <div className="d-flex align-items-center justify-content-start">
                  <button
                    type="button"
                    className="btn btn-primary me-3"
                    disabled={isSubmitLoading}
                    onClick={() => handleSubmit("No")}
                  >
                    {isSubmitLoading ? "Updating..." : "Update"}
                  </button>
                  {data.status === "draft" && (
                    <button
                      type="button"
                      className="btn btn-secondary me-3"
                      onClick={() => handleSubmit("Yes")}
                      disabled={isSubmitLoading}
                    >
                      Save as Draft
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditDocumentVersion;
